/* eslint-disable */
'use client'

import { useEffect } from 'react'

export default function OneSignalSetup() {
  useEffect(() => {
    // Initialize OneSignal
    window.OneSignalDeferred = window.OneSignalDeferred || []

    window.OneSignalDeferred.push(async function (OneSignal) {
      await OneSignal.init({
        appId: process.env.NEXT_PUBLIC_ONESIGNAL_APP_ID, // Replace with your App ID from OneSignal dashboard
        // safari_web_id: 'YOUR_SAFARI_WEB_ID', // Optional - for Safari support
        // notifyButton: {
        //   enable: true, // Shows OneSignal's default bell icon
        // },
        // allowLocalhostAsSecureOrigin: true, // For local testing

        // // Prompt options
        // promptOptions: {
        //   slidedown: {
        //     enabled: true,
        //     autoPrompt: false, // Set to true to prompt automatically
        //     timeDelay: 10, // Seconds before showing prompt
        //   },
        // },
      })

      // Optional: Auto-prompt users to subscribe
      // Uncomment the line below if you want automatic prompting
      // OneSignal.Slidedown.promptPush();

      // Track subscription status
      OneSignal.User.PushSubscription.addEventListener('change', (event) => {
        console.log('Push subscription changed:')
        if (event.current.token) {
          console.log('User is now subscribed')
          // You can track this in your analytics
        }
      })
    })
  }, [])

  return (
    <script
      src="https://cdn.onesignal.com/sdks/web/v16/OneSignalSDK.page.js"
      async
      id="onesignal"
    />
  )
  // This component doesn't render anything
}
